import React from 'react';
import {RoutePermittedRole} from '../../shared/constants/AppEnums';
import OrderDetails from './orders-list/order-details';

const OrdersList = React.lazy(() => import('./orders-list'));
const ReturnOrExchange = React.lazy(() => import('./return-or-exchange'));

export const ordersConfig = [
  {
    permittedRole: RoutePermittedRole.user,
    path: '/orders/orders-list',
    element: <OrdersList />,
  },
  {
    permittedRole: RoutePermittedRole.user,
    path: '/orders/orders-list/order-details/:id',
    element: <OrderDetails />,
  },
  {
    permittedRole: RoutePermittedRole.user,
    path: '/orders/return-or-exchange',
    element: <ReturnOrExchange />,
  },
];
